import React, { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useFallbackUrl, useNavigator } from "../../components/AppHistory";
import { ModalComponent } from "../../pages/routes";
import { WrapNotesDialog } from "./components/WrapNotesDialog";
import { useWrapUpNotes } from "./hooks/useWrapUpNotes";
import { useSaveWrapUpNote } from "./hooks/useSaveWrapUpNote";

export const WrapNotesContainer: ModalComponent = ({ fallbackUrl }) => {
  useFallbackUrl(fallbackUrl);
  const { confirmOverlay, closeOverlay } = useNavigator();
  const { accountNumber } = useParams();

  const { errors, isFetching, accountDetails, types } = useWrapUpNotes(
    accountNumber!,
  );

  const {
    startTime,
    saveWrapUpNote,
    error: saveError,
    status: saveStatus,
  } = useSaveWrapUpNote(accountNumber!);

  //Callbacks
  const onSave = useCallback(
    async (formData: Record<string, any>) => {
      const status = await saveWrapUpNote(formData);

      if (status === 201) {
        confirmOverlay({
          pathname: fallbackUrl,
          state: {
            success: `Wrap-up notes saved.`,
          },
        });
      }
    },
    [fallbackUrl, saveWrapUpNote, confirmOverlay],
  );

  const onCancel = useCallback(() => {
    closeOverlay();
  }, [closeOverlay]);

  return (
    <WrapNotesDialog
      startTime={startTime}
      /* istanbul ignore next */
      isLoading={isFetching && !(types && accountDetails)}
      fetchErrors={errors}
      saveError={saveError}
      isSaving={saveStatus === "loading"}
      wrapNotesTypes={types}
      accountDetails={accountDetails}
      onCancel={onCancel}
      onSubmit={onSave}
    />
  );
};
